export default __webpack_public_path__ + "static/media/gold.08906851.png";